// import { baseServer } from '@/api/index'
export default {
  name: 'getImgUrl',
  methods: {
    getImgUrl (arr, attr = 'url') {
      this.$getPath({
        name: arr.filter(k => k[attr] !== '').map(e => e[attr]).join()
      }).then(obj => {
        if (obj) {
          arr.forEach((e) => {
            if (e[attr]) {
              this.$set(e, 'fileUrl', obj[e[attr]] || '')
            }
          })
        }
      })
    },
    // getMoreImgUrl (allData, dataArr) {
    //   let nameArr = []
    //   dataArr.forEach(e1 => {
    //     allData[e1.name].forEach(e2 => {
    //       if (Array.isArray(e2)) {
    //         e2.forEach(e3 => {
    //           if (e3.controlType === e1.controlType && e3[e1.value].length) {
    //             nameArr = nameArr.concat(e3[e1.value].filter(k => k[e1.value] !== '').map(e => e[e1.attr]))
    //           } else if (e3.controlType === 'UploadImg' && e3.controlValue.length) {
    //             nameArr = nameArr.concat(e3.controlValue.filter(k => k.url !== '').map(e => e.url))
    //           }
    //         })
    //       } else {
    //         if (e2.controlType === e1.controlType && e2[e1.value].length) {
    //           nameArr = nameArr.concat(e2[e1.value].filter(k => k[e1.attr] !== '').map(e => e[e1.attr]))
    //         }
    //       }
    //     })
    //   })
    //   // return new Promise((resolve) => {
    //   //   baseServer.getImg({
    //   //     name: nameArr.join()
    //   //   }).then(res => {
    //   //     let { code, data } = res
    //   //     if (code === '0') {
    //   //       if (data) {
    //   //         dataArr.forEach(e1 => {
    //   //           allData[e1.name].forEach((e2) => {
    //   //             if (e2.controlType === e1.controlType && e2[e1.value].length) {
    //   //               e2[e1.value].forEach((e) => {
    //   //                 if (e[e1.attr]) {
    //   //                   this.$set(e, 'imgUrl', data[e[e1.attr]] || '')
    //   //                 }
    //   //               })
    //   //             }
    //   //           })
    //   //         })
    //   //       }
    //   //       resolve(data)
    //   //     } else {
    //   //       resolve({})
    //   //     }
    //   //   }).catch(() => {
    //   //     resolve({})
    //   //   })
    //   // })
    //   this.$getUrl({
    //     name: nameArr.join()
    //   }).then(obj => {
    //     if (obj) {
    //       dataArr.forEach(e1 => {
    //         allData[e1.name].forEach((e2) => {
    //           if (Array.isArray(e2)) {
    //             e2.forEach(e3 => {
    //               if (e3.controlType === e1.controlType && e3[e1.value].length) {
    //                 e3[e1.value].forEach((e) => {
    //                   if (e[e1.attr]) {
    //                     this.$set(e, 'imgUrl', obj[e[e1.attr]] || '')
    //                   }
    //                 })
    //               } else if (e3.controlType === 'UploadImg' && e3.controlValue.length) {
    //                 e3.controlValue.forEach((e) => {
    //                   if (e.url) {
    //                     this.$set(e, 'imgUrl', obj[e.url] || '')
    //                   }
    //                 })
    //               }
    //             })
    //           } else {
    //             if (e2.controlType === e1.controlType && e2[e1.value].length) {
    //               e2[e1.value].forEach((e) => {
    //                 if (e[e1.attr]) {
    //                   this.$set(e, 'imgUrl', obj[e[e1.attr]] || '')
    //                 }
    //               })
    //             }
    //           }
    //         })
    //       })
    //     }
    //   })
    // }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/getImgUrl.js